import "maplibre-gl/dist/maplibre-gl.css";

import { createComponent } from "@opendash/state";
import React from "react";
import ReactMap from "react-map-gl/maplibre";
import { $geo, MapboxMap } from "..";

export type MapProps = React.PropsWithChildren<{
  width: number | string;
  height: number | string;
  initialLatitude?: number;
  initialLongitude?: number;
  initialZoom?: number;
  interactiveLayerIds?: string[];
  onMouseDown?: (e: import("mapbox-gl").MapLayerMouseEvent) => void;
  onMouseUp?: (e: import("mapbox-gl").MapLayerMouseEvent) => void;
  onMouseOver?: (e: import("mapbox-gl").MapLayerMouseEvent) => void;
  onMouseMove?: (e: import("mapbox-gl").MapLayerMouseEvent) => void;
  onClick?: (e: import("mapbox-gl").MapLayerMouseEvent) => void;
  onDblClick?: (e: import("mapbox-gl").MapLayerMouseEvent) => void;
  onMouseEnter?: (e: import("mapbox-gl").MapLayerMouseEvent) => void;
  onMouseLeave?: (e: import("mapbox-gl").MapLayerMouseEvent) => void;
  onMouseOut?: (e: import("mapbox-gl").MapLayerMouseEvent) => void;
  onContextMenu?: (e: import("mapbox-gl").MapLayerMouseEvent) => void;
  onTouchStart?: (e: import("mapbox-gl").MapLayerTouchEvent) => void;
  onTouchEnd?: (e: import("mapbox-gl").MapLayerTouchEvent) => void;
  onTouchMove?: (e: import("mapbox-gl").MapLayerTouchEvent) => void;
  onTouchCancel?: (e: import("mapbox-gl").MapLayerTouchEvent) => void;
  onMoveStart?: (
    e: import("react-map-gl/maplibre").ViewStateChangeEvent
  ) => void;
  onMove?: (e: import("react-map-gl/maplibre").ViewStateChangeEvent) => void;
  onMoveEnd?: (e: import("react-map-gl/maplibre").ViewStateChangeEvent) => void;
  onDragStart?: (
    e: import("react-map-gl/maplibre").ViewStateChangeEvent
  ) => void;
  onDrag?: (e: import("react-map-gl/maplibre").ViewStateChangeEvent) => void;
  onDragEnd?: (e: import("react-map-gl/maplibre").ViewStateChangeEvent) => void;
  onZoomStart?: (
    e: import("react-map-gl/maplibre").ViewStateChangeEvent
  ) => void;
  onZoom?: (e: import("react-map-gl/maplibre").ViewStateChangeEvent) => void;
  onZoomEnd?: (e: import("react-map-gl/maplibre").ViewStateChangeEvent) => void;
  onRotateStart?: (
    e: import("react-map-gl/maplibre").ViewStateChangeEvent
  ) => void;
  onRotate?: (e: import("react-map-gl/maplibre").ViewStateChangeEvent) => void;
  onRotateEnd?: (
    e: import("react-map-gl/maplibre").ViewStateChangeEvent
  ) => void;
  onPitchStart?: (
    e: import("react-map-gl/maplibre").ViewStateChangeEvent
  ) => void;
  onPitch?: (e: import("react-map-gl/maplibre").ViewStateChangeEvent) => void;
  onPitchEnd?: (
    e: import("react-map-gl/maplibre").ViewStateChangeEvent
  ) => void;
  onWheel?: (e: import("mapbox-gl").MapWheelEvent) => void;
  onBoxZoomStart?: (e: import("mapbox-gl").MapBoxZoomEvent) => void;
  onBoxZoomEnd?: (e: import("mapbox-gl").MapBoxZoomEvent) => void;
  onBoxZoomCancel?: (e: import("mapbox-gl").MapBoxZoomEvent) => void;
  onResize?: (e: import("mapbox-gl").MapboxEvent<undefined>) => void;
  onLoad?: (e: import("mapbox-gl").MapboxEvent<undefined>) => void;
  onRender?: (e: import("mapbox-gl").MapboxEvent<undefined>) => void;
  onIdle?: (e: import("mapbox-gl").MapboxEvent<undefined>) => void;
  onError?: (e: import("mapbox-gl").ErrorEvent) => void;
  onRemove?: (e: import("mapbox-gl").MapboxEvent<undefined>) => void;
  onData?: (
    e:
      | import("mapbox-gl").MapSourceDataEvent
      | import("mapbox-gl").MapStyleDataEvent
  ) => void;
  onStyleData?: (e: import("mapbox-gl").MapStyleDataEvent) => void;
  onSourceData?: (e: import("mapbox-gl").MapSourceDataEvent) => void;
  mapRef?: React.MutableRefObject<MapboxMap>;
}>;

export const Map = createComponent<MapProps>(function Map({
  width = "100%",
  height = "400px",
  initialLatitude = 51.163375,
  initialLongitude = 10.447683,
  initialZoom = 8,
  children,
  ...props
}) {
  const style: React.CSSProperties = React.useMemo(
    () => ({
      width,
      height,
    }),
    [width, height]
  );

  const initialViewState = React.useMemo(
    () => ({
      longitude: initialLongitude,
      latitude: initialLatitude,
      zoom: initialZoom,
    }),
    [initialLatitude, initialLongitude, initialZoom]
  );

  if (!$geo.vectorStyleAvailable || !$geo.vectorStyle) {
    console.error(new Error("Feature 'vectorStyle' not available."));
    return null;
  }

  return (
    <ReactMap
      mapStyle={$geo.vectorStyle}
      //mapStyle="https://raw.githubusercontent.com/osm-in/mapbox-gl-styles/master/osm-mapnik.json"
      style={style}
      initialViewState={initialViewState}
      //@ts-ignore
      ref={props.mapRef}
      {...props}
    >
      {children}
    </ReactMap>
  );
});
